// Message for a failed fetch Response.
//
// DRF answers errors as JSON ({detail} or per-field lists). A gateway timeout
// (nginx 502/503/504) or a crashed server answers with an HTML page instead, so
// reading it as JSON yields nothing — which used to surface as a bare "{}".
// A gateway error is also the one case where the request may well have gone
// through on the server, so the message says so.
export async function responseErrorMessage(res) {
  const data = await res.json().catch(() => null);

  if (data && typeof data === "object") {
    const msg = data.detail || data.non_field_errors?.[0];
    if (msg) return msg;
    if (Object.keys(data).length > 0) return JSON.stringify(data);
  }

  if (res.status === 502 || res.status === 503 || res.status === 504) {
    return "Server terlalu lama merespons. Datanya mungkin sudah tersimpan — cek daftar dulu sebelum mengulang.";
  }
  return `Permintaan gagal (kode ${res.status}).`;
}
